/**
 * Centered loading indicator for modal bodies and inline async states.
 *
 * @param {{ size?: number, label?: string }} props
 */
export default function Spinner({ size = 28, label = "Loading" }) {
  return (
    <div
      role="status"
      aria-label={label}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          border: "3px solid var(--border-bright)",
          borderTopColor: "var(--accent)",
          animation: "idwiz-spin 0.7s linear infinite",
        }}
      />
    </div>
  );
}
